import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";
import { FormattedDate, FormattedMessage, intlShape } from "react-intl";
import classNames from "classnames";
import _ from "lodash";

import { BSModal, CheckboxButton, EditButton } from "../../../common";
import { BasicFollowUpFields, MultiFollowUpFields } from "../../clients/client/notes";

import followUpPriorities from "../../clients/client/notes/enums/followUpPriorities";
import { INCIDENT, SPECIAL_MODIFICATION } from "../../clients/client/notes/enums/followUpTypes";
import followUpStatusTypes from "../../clients/client/notes/enums/followUpStatusTypes";
import { FOLLOW_UPS, FOLLOW_UPS_GRAPHQL, FOLLOW_UP_CATEGORIES } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";
import * as followUpActions from "../followUpActions";

import FollowUpsFilter from "./FollowUpsFilter";
import followUpFilters, { FROM_ME, TO_ME } from "./enums/followUpFilters";

import { getTenantFromURL } from "../../../common/MultiTenancy/MultiTenancyHelper";

import DataTableV2 from "../../../common/DataTableV2/DataTableV2";
import { getLocalStorageFilter, setLocalStorageFilters } from "../../../common/LocalStorageFilters/LocalStorageFilters";
import { getQueryParams, getUrlParam, updateCurrentURLV2 } from "../../../../../utils/url";
import {
    buildGraphQLQueryParams,
    formatMultipleFilters,
    toGraphQLFormat,
    toGraphQLSortFormat,
} from "../../../common/GraphQL/GraphQLQueryHelper";
import { LIKE, EQUALS } from "../../../common/GraphQL/GraphQLFilterTypes";
import { toast } from "react-toastify";
import { actions } from "redux-form";
import { getFollowUpCols } from "./FollowUpsCols";
import userHasAccess from "../../../../utils/userHasAccess";
import { FINTECH } from "../../../../utils/Roles";

const filtrableColsInitState = {
    selectedPriorities: {
        col: "priority",
        key: "priorityVal",
        modelName: "followUps",
        urlKey: "priority",
        items: [],
        apiFilters: [],
        filterList: [],
        enumRef: followUpPriorities,
    },
    selectedCreatedAt: {
        col: "createdAt",
        key: "createdAt",
        modelName: "followUps",
        urlKey: "createdAt",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedDeadline: {
        col: "deadline",
        key: "deadline",
        modelName: "followUps",
        urlKey: "deadline",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedMembers: {
        col: "memberName",
        key: "memberName",
        modelName: "followUps",
        urlKey: "memberName",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedCategories: {
        col: "followUpCategory",
        key: "followUpCategory",
        modelName: "followUps",
        urlKey: "followUpCategory",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedDescriptions: {
        col: "description",
        key: "description",
        modelName: "followUps",
        urlKey: "description",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedCreators: {
        col: "createdByUser",
        key: "createdByUser",
        modelName: "followUps",
        urlKey: "createdByUser",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedAssigned: {
        col: "recipientUser",
        key: "recipientUser",
        modelName: "followUps",
        urlKey: "recipientUser",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedStatuses: {
        col: "followUpStatusType",
        key: "followUpStatusTypeVal",
        modelName: "followUps",
        urlKey: "followUpStatusType",
        items: [],
        apiFilters: [],
        filterList: [],
        enumRef: followUpStatusTypes,
    },
    selectedClients: {
        col: "client",
        key: "client",
        modelName: "followUps",
        urlKey: "client",
        items: [],
        apiFilters: [],
        filterList: [],
    },
    selectedShowClients: {
        col: "isVip",
        key: "isVip",
        modelName: "followUps",
        urlKey: "isVip",
        items: [],
        apiFilters: [],
        filterList: [],
    }
};
class FollowUpsDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showSelectedCheckboxes: 0,
            filters: props.filters,
            followUpType: "",
            selection: [],
            showModal: false,
            showConfirmationModal: false,
            loadedFilters: false,
            checkClosedFollowUps: false,
            checkedDisplayClients: false,
            datatableName: "followUps.followUpsDataTable",
            sortBy: ["follow_ups.created_at:desc"],
            modelName: "followUps",
            isFilterError: false,
            filtrableCols: JSON.parse(
                JSON.stringify(filtrableColsInitState)
            ) /** Deep copy is needed to not modify the initstate object. */,
            overrideToMe: false,
            fetchingCheckboxFilter: false
        };

        this.checkboxes = {};

        this.createEmptyFollowUpModel = this.createEmptyFollowUpModel.bind(this);
        this.createFollowUp = this.createFollowUp.bind(this);
        this.closeFollowUpForm = this.closeFollowUpForm.bind(this);
        this.getData = _.debounce(this.getData.bind(this), 350);
        this.onClick = this.onClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.openFollowUpForm = this.openFollowUpForm.bind(this);
        this.setCellClassNames = this.setCellClassNames.bind(this);
        this.reload = this.reload.bind(this);
        this.toggleClosedFollowUps = this.toggleClosedFollowUps.bind(this);
        this.updateFollowUp = this.updateFollowUp.bind(this);
        this.updateFollowUps = this.updateFollowUps.bind(this);
        this.updateFollowUpFilters = this.updateFollowUpFilters.bind(this);
        this.updateMasterCheckbox = this.updateMasterCheckbox.bind(this);
        this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
        this.confirmOnClose = this.confirmOnClose.bind(this);
        this.findNestedState = this.findNestedState.bind(this);
        this.onColChange = this.onColChange.bind(this);
        this.generateFilters = this.generateFilters.bind(this);
        this.reapplyFilters = this.reapplyFilters.bind(this);
        this.applyFrontFilterLists = this.applyFrontFilterLists.bind(this);
        this.createFilterLists = this.createFilterLists.bind(this);
        this.clearFilterList = this.clearFilterList.bind(this);
        this.loadFiltersAndSortBy = this.loadFiltersAndSortBy.bind(this);
        this.getColsAPIFilters = this.getColsAPIFilters.bind(this);
        this.setAsyncSearchFilter = this.setAsyncSearchFilter.bind(this);
        this.generateCustomItemOptions = this.generateCustomItemOptions.bind(this);
        this.generateActionButtons = this.generateActionButtons.bind(this);
        this.resetFiltersState = this.resetFiltersState.bind(this);
        this.isDefaultFilterOverridable = this.isDefaultFilterOverridable.bind(this);
        this.toggleShowClients = this.toggleShowClients.bind(this);
        this.deactivateCheckboxes = this.deactivateCheckboxes.bind(this);
        this.reloadForModal = this.reloadForModal.bind(this);
    }

    componentWillMount() {
        try {
            this.setState({ fetchingCheckboxFilter: true });
            this.props.dataActions.clearDataList(FOLLOW_UPS);
            const [existingFilters, existingSortBy] = this.loadFiltersAndSortBy();
            const overridableFilter = this.isDefaultFilterOverridable();

            this.updateFollowUpFilters(
                {
                    followUpsFilter: TO_ME.value,
                    memberFilter: "",
                },
                {
                    existingFilters,
                    existingSortBy,
                },
                overridableFilter,
                true
            );
        } catch (e) {
            this.setState({ isFilterError: true }, () => {
                toast(<FormattedMessage id="pleaseResetFilters" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const canInsertFollowUpCategories =
            nextProps.followUpCategories &&
            nextProps.followUpCategories.length > 0 &&
            this.state.filtrableCols["selectedCategories"].filterList.length === 0;

        if (canInsertFollowUpCategories) {
            this.applyFrontFilterLists(nextProps);
        }
    }

    componentDidUpdate() {
        if (this.props.sortBy !== this.state.sortBy) {
            this.setState({ sortBy: this.props.sortBy });
        }
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(FOLLOW_UPS);
        this.props.dataActions.clearDataList(FOLLOW_UP_CATEGORIES);
        /** Clearing follow up categories is necessary on unmount. For example, if a user has a fr-CA account,
         * then logs out and logs back in with an en-CA account, the redux store will still have french values
         * before the component mounts and does the follow-up-categories request, which can cause an error.
         */
    }

    generateFilters(values, valueKey, modelName, colName) {
        /**
         * Function will reconstruct selected filter values into an
         * API format filter.
         */

        let filterString = "";

        if (values) {
            let selectedFilters = values.map((filter) => filter[valueKey]);

            for (let filter of selectedFilters) {
                filterString += modelName + "." + colName + EQUALS + filter + ";";
            }
        }
        return filterString;
    }

    applyFrontFilterLists(nextProps) {
        const { formatMessage } = this.context.intl;

        const userLocale = localStorage.getItem("languageCode") || "en-CA";
        let filtrableCols = { ...this.state.filtrableCols };

        if (
            nextProps.followUpCategories.length > 0 &&
            this.state.filtrableCols.selectedCategories.filterList.length == 0
        ) {
            const followUpCategoriesArr = nextProps.followUpCategories.map((category) => {
                return { followUpCategory: category.localizations[userLocale].name };
            });
            filtrableCols.selectedCategories.filterList = followUpCategoriesArr;
        }

        const statusLocales = followUpStatusTypes.map((status) => {
            return {
                followUpStatusType: formatMessage({ id: status.key }),
                followUpStatusTypeVal: status.value,
            };
        });

        const priorityLocales = followUpPriorities.map((priority) => {
            return {
                priority: formatMessage({ id: priority.key }),
                priorityVal: priority.value,
            };
        });

        filtrableCols.selectedStatuses.filterList = [
            ...this.state.filtrableCols.selectedStatuses.filterList,
            ...statusLocales,
        ];
        filtrableCols.selectedPriorities.filterList = [
            ...this.state.filtrableCols.selectedPriorities.filterList,
            ...priorityLocales,
        ];
        this.setState({ filtrableCols });
    }

    loadFiltersAndSortBy() {
        let colNames = [];
        let allLocalStorageFilters = new Set();
        let sortByValue = "";
        const { formatMessage } = this.context.intl;

        for (const key of Object.keys(this.state.filtrableCols)) {
            colNames.push(this.state.filtrableCols[key]["col"]);
        }

        colNames.forEach((col) => {
            const localStorageKey = this.state.datatableName + "." + col;
            const localStorage = getLocalStorageFilter(localStorageKey);

            let allColFilters = [];
            const queryParams = getQueryParams(col);

            queryParams &&
                queryParams.forEach((param) => {
                    const isLikeFilter = param.includes("like=");
                    if (isLikeFilter) {
                        param = param.split("like=")[1];
                    }
                    const formattedFilter = !isLikeFilter
                        ? this.state.modelName + "." + col + EQUALS + param
                        : this.state.modelName + "." + col + LIKE + param;
                    allColFilters.push(formattedFilter);
                    allLocalStorageFilters.add(formattedFilter);
                });

            if (allColFilters.length > 0) {
                /**
                 * If query params are present, we want to override the localstorage filters.
                 */
                const localStorageVal = allColFilters.join(";");
                setLocalStorageFilters(localStorageKey, localStorageVal);
            }

            if (localStorage && !queryParams) {
                const filters = localStorage.split(";"); // One localstorage can have multiple filters.
                filters.forEach((filter) => {
                    allLocalStorageFilters.add(filter);
                });
            }
        });

        allLocalStorageFilters = Array.from(allLocalStorageFilters).filter((filter) => filter);
        let filtrableCols = { ...this.state.filtrableCols };
        allLocalStorageFilters.forEach((filter) => {
            const filterEqualsArr = filter.split(EQUALS);
            const filterLikeArr = filter.split(LIKE);

            const filterArr = filterEqualsArr.length > 1 ? filterEqualsArr : filterLikeArr;
            const filterKey = filterArr[0].split(".")[1];

            const nestedStateName = this.findNestedState(this.state, filterKey, true);
            /**
             * We have to treat enum cols seperately. Since they have 2 values in their objects:
             * Label name and value for db, we need to loop over the enum file array.
             */

            filtrableCols[nestedStateName]["apiFilters"].push(filter);
            if (filtrableCols[nestedStateName]["enumRef"]) {
                const formattedMessageEnum = filtrableCols[nestedStateName]["enumRef"].filter(
                    (filter) => filter.value === filterArr[1]
                );

                filtrableCols[nestedStateName]["items"].push({
                    [filterKey]:
                        formattedMessageEnum.length > 0
                            ? formatMessage({ id: formattedMessageEnum[0].key })
                            : filterArr[1],
                    [filterKey + "Val"]: filterArr[1],
                });
            } else {
                filtrableCols[nestedStateName]["items"].push({
                    [filterKey]: filterArr[1],
                });
            }
        });

        const sort = getUrlParam("sort");

        if (sort) {
            setLocalStorageFilters(this.state.datatableName + "." + "sortBy", sort);
        }

        sortByValue = getLocalStorageFilter(this.state.datatableName + "." + "sortBy");

        this.setState({
            filters: allLocalStorageFilters,
            filtrableCols: filtrableCols,
            sortBy: [sortByValue ? sortByValue : "follow_ups.created_at:desc"],
        });
        return [allLocalStorageFilters, sortByValue];
    }

    getGraphQLQuery(filter, sortBy, offset, limit, queryName, q) {
        const colsStr = `
                followUpId
                extraData
                priority
                createdAt
                updatedAt
                memberName
                memberClient
                clientId
                createdByUser {
                    firstName
                    lastName
                  }
                closedByUser {
                    firstName
                    lastName
                }
                deadline
                description
                client {
                    name
                    clientStatusType
                    isArchived
                }
                member {
                    memberId
                    firstName
                    lastName
                    isArchived
                    client {
                        clientId
                        name
                    }
                    memberIdentifier
                }
                followUpCategory {
                    followUpCategoryId
                    localizations
                }
                followUpStatusType
                recipientUser {
                    firstName
                    lastName
                  }
                commentsCount
                attachmentsCount
                followUpGuid
        `;
        return buildGraphQLQueryParams("followUps", filter, sortBy, offset, limit, colsStr, queryName, q);
    }

    clearFilterList(colKey) {
        const stateName = this.findNestedState(this.state, colKey);

        this.setState((prevState) => ({
            filtrableCols: {
                ...prevState.filtrableCols,
                [stateName]: {
                    ...prevState["filtrableCols"][stateName],
                    filterList: [],
                },
            },
        }));
    }

    isDefaultFilterOverridable() {
        /**
         * Function that will check for two cases:
         * 1- Are we passing the flag: skipRecipientUser=true; in urlParams (flag to override default behaviour) ?
         * 2- Are we passing recipientUser=<recipient_user_id> in urlParams ?
         * 3- Does a localStorage value exist for recipientUser ? 
         */

        const skipRecipientUserFlag = "skipRecipientUser=true";
        const recipientUserColName = filtrableColsInitState.selectedAssigned.col;
        const localStorageKey = this.state.datatableName + "." + recipientUserColName;
        const localStorage = getLocalStorageFilter(localStorageKey); /** Get recipient user localStorage. */

        const flagQueryParam = getQueryParams("skipRecipientUser");
        const recipientUserQueryParams = getQueryParams(recipientUserColName);

        let allQueryParams = [];

        if (flagQueryParam && flagQueryParam[0] === "true") {
            allQueryParams.push(skipRecipientUserFlag);
        }

        if (recipientUserQueryParams) {
            allQueryParams.push(recipientUserQueryParams);
        }

        let override = false;

        if (allQueryParams && allQueryParams.length > 0) {
            /** Means we found a recipient_user query param. */
            this.setState({ overrideToMe: true });
            override = true;

            if (allQueryParams.includes(skipRecipientUserFlag)) {
                /** Since the skipRecipientUserFlag is not a real db value for follow_ups,
                 * we want to remove it from the query params to avoid any errors.
                 */
                const newURL = new URL(window.location.href);
                const searchParams = newURL.searchParams;
                searchParams.delete("skipRecipientUser");
                window.history.pushState({ path: newURL.href }, "", newURL.href);
            }
        }

        if (localStorage && localStorage.length > 0) {
            this.setState({ overrideToMe: true });
            override = true;
        }

        return override;
    }
    
    deactivateCheckboxes() {
        this.setState({ fetchingCheckboxFilter: true });
    }

    confirmOnClose() {
        this.setState({
            showModal: false,
            showConfirmationModal: false,
        });
    }
    setCellClassNames(followUp) {
        return classNames({
            archived: followUp.isArchived,
        });
    }

    closeConfirmationModal() {
        this.setState({ showConfirmationModal: false });
    }
    closeFollowUpForm() {
        const form = !!this.refs.form.getWrappedInstance().refs.wrapped
            ? this.refs.form.getWrappedInstance().refs.wrapped.getWrappedInstance()
            : null;
        if (form.props.dirty) {
            this.setState({ showConfirmationModal: true });
        } else {
            this.setState({ showModal: false });
        }
    }

    createEmptyFollowUpModel() {
        const { auth } = this.props;
        return {
            date: <FormattedDate value={new Date()} year="numeric" month="long" day="2-digit" />,
            userId: auth.user.userId,
            user: `${auth.user.firstName} ${auth.user.lastName}`,
            priority: "MEDIUM",
            followUpType: this.state.followUpType,
            followUpOriginType: "MANUAL",
            followUpStatusType: "NEW",
            generateFollowUp: true,
            subType: "",
            description: "",
            transactionAmount: "",
            followUpGuid: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }),
        };
    }

    async createEditableFollowUpModel(followUpId) {
        const followUpRes = await this.props.dataActions.getDataItem(FOLLOW_UPS, followUpId, {
            fields: "createdByUser(userId,firstName,lastName),recipientUser(userId,firstName,lastName),*",
        });
        const followUp = followUpRes.payload.data;
        let followUpData = "";

        let memberIdentifier = "";
        if (followUp.member && followUp.member.memberIdentifier) {
            memberIdentifier = followUp.member.memberIdentifier;
        }
        else if (followUp.memberIdentifier) {
            memberIdentifier = followUp.memberIdentifier;
        }
        if (followUp && followUp.clientId) {
            const user = followUp.createdByUserId ? (
                `${followUp.createdByUser.firstName} ${followUp.createdByUser.lastName}`
            ) : (
                <FormattedMessage id="members.followUps.types.systemNote" />
            );
            followUpData = {
                ...followUp,
                priority: followUp.priority,
                date: <FormattedDate value={followUp.createdAt} year="numeric" month="long" day="2-digit" />,
                deadline: followUp.deadline,
                user,
                subType: followUp.incidentType || followUp.specialModificationType,
                incidentType: followUp.incidentType|| null,
                specialModificationType: followUp.specialModificationType|| null,
                generateFollowUp: !!followUp.clientId,
                clientId: followUp.clientId,
                clientName: !!followUp.client ? followUp.client.name : "",
                closeFollowUp: followUp.followUpStatusType === "CLOSED",
                contactPhoneNumber: !!followUp.client ? followUp.client.contactPhoneNumber : followUp.memberPhoneNumber,
                contactEmailAddress: !!followUp.client
                    ? followUp.client.contactEmailAddress
                    : followUp.memberEmailAddress,
                followUpClosedOn: !!followUp.closedDate ? (
                    <FormattedDate value={followUp.closedDate} year="numeric" month="long" day="2-digit" />
                ) : null,
                followUpClosedBy: !!followUp.closedByUser
                    ? `${followUp.closedByUser.firstName} ${followUp.closedByUser.lastName}`
                    : null,
                memberIdentifier: memberIdentifier
            };
        } else {
            followUpData = followUp && {
                ...followUp,
                priority: followUp.priority,
                date: <FormattedDate value={followUp.createdAt} year="numeric" month="long" day="2-digit" />,
                deadline: followUp.deadline,
                user: !!followUp.createdByUser
                    ? `${followUp.createdByUser.firstName} ${followUp.createdByUser.lastName}`
                    : null,
                subType: followUp.incidentType || followUp.specialModificationType,
                incidentType: followUp.incidentType|| null,
                specialModificationType: followUp.specialModificationType|| null,
                closeFollowUp: followUp.followUpStatusType === "CLOSED",
                generateFollowUp: true,
                memberName: !!followUp.member
                    ? `${followUp.member.firstName} ${followUp.member.lastName}`
                    : followUp.memberName,
                memberIdentifier: !!followUp.member ? followUp.member.memberIdentifier : followUp.memberIdentifier,
                memberClient:
                    !!followUp.member && !!followUp.member.client ? followUp.member.client.name : followUp.memberClient,
                memberPhoneNumber: !!followUp.member ? followUp.member.customPhoneNumber : followUp.memberPhoneNumber,
                memberEmailAddress: !!followUp.member
                    ? followUp.member.customEmailAddress
                    : followUp.memberEmailAddress,
                profilePhone: !!followUp.member ? followUp.member.phoneNumber : "",
                profileEmail: !!followUp.member ? followUp.member.emailAddress : "",
                followUpClosedOn: !!followUp.closedDate ? (
                    <FormattedDate value={followUp.closedDate} year="numeric" month="long" day="2-digit" />
                ) : null,
                followUpClosedBy: !!followUp.closedByUser
                    ? `${followUp.closedByUser.firstName} ${followUp.closedByUser.lastName}`
                    : null,
            };
        }

        followUpData.readOnly = followUp.member ? followUp.member.isArchived : false;

        const resObj = {
            type: followUpRes.type,
            payload: {
                data: {
                    ...followUpData,
                },
            },
        };

        return Promise.resolve(resObj);
        /**
         * Promise must be returned with the built data.
         * Since EditButton expects getData() to return a promise.
         */
    }

    createFollowUp(fields) {
        this.setState({ fetchingCheckboxFilter: true });
        if (fields.followUpAttachments && fields.followUpAttachments.length > 0) {
            fields.followUpAttachments.forEach((followUpAttachment) => {
                followUpAttachment.objectPath.startsWith(`${getTenantFromURL()}/`) ?
                    followUpAttachment.objectPath = followUpAttachment.objectPath.replace(`${getTenantFromURL()}/`, '') :
                    followUpAttachment.objectPath;
            });
        }
        const values = {
            createdByUserId: fields.userId,
            description: fields.description,
            attachments: fields.followUpAttachments,
            followUpGuid: fields.followUpGuid,
            followUpOriginType: fields.followUpOriginType,
            followUpStatusType: "OPEN",
            followUpType: fields.followUpType,
            memberId: fields.memberId,
            clientId: fields.clientId,
            memberIdentifier: fields.memberIdentifier,
            memberClient: fields.memberClient,
            memberPhoneNumber: fields.memberPhoneNumber,
            memberEmailAddress: fields.memberEmailAddress,
            transactionAmount: fields.transactionAmount || null,
            followUpCategoryId: fields.followUpCategoryId,
        };
        if (fields.priority) {
            values.priority = fields.priority;
            values.deadline = fields.deadline;
        }
        if (fields.generateFollowUp) {
            switch (fields.followUpType) {
                case INCIDENT.value: {
                    values.incidentType = fields.subType;
                    break;
                }
                case SPECIAL_MODIFICATION.value: {
                    values.specialModificationType = fields.subType;
                    break;
                }
            }
            values.recipientUserId = fields.recipientUserId;
        }
        this.props.dataActions.createDataItem(FOLLOW_UPS, values).then(() => {
            this.props.dataActions.getDataCount(
                FOLLOW_UPS,
                [FOLLOW_UPS.archiveFilter, `followUps.recipientUserId==${this.props.auth.user.userId}`],
                "FOLLOW_UPS"
            );

            this.getData(this.props.offset, this.props.limit, this.props.q, this.state.sortBy, this.state.filters);
        });
    }

    onClick() {
        this.refs.form.getWrappedInstance().submit();
    }

    onSubmit(fields) {
        this.createFollowUp(fields);
        this.setState({ showModal: false });
    }

    openFollowUpForm(followUpType) {
        this.setState({ showModal: true, followUpType });
    }

    toggleShowClients() {
        const isShowClientsChecked = (!!this.state.filters.find((filter) => filter.includes(FOLLOW_UPS.classificationFilter)));
        let filtrableCols = JSON.parse(JSON.stringify(this.state.filtrableCols));

        let urlValues = [(!isShowClientsChecked).toString()];

        let filters = this.state.filters;
        if (isShowClientsChecked) {
            filtrableCols["selectedShowClients"]["items"] = [];
            filtrableCols["selectedShowClients"]["apiFilters"] = [];
            filters = filters.filter((f) => !FOLLOW_UPS.classificationFilter.includes(f));
            setLocalStorageFilters(
                this.state.datatableName + "." + filtrableColsInitState.selectedShowClients.urlKey,
                ""
            );
            updateCurrentURLV2(filtrableColsInitState.selectedShowClients.urlKey, "");
        }
        else {
            filters.push(FOLLOW_UPS.classificationFilter);
            filtrableCols["selectedShowClients"]["items"] = [true];
            filtrableCols["selectedShowClients"]["apiFilters"] = [FOLLOW_UPS.classificationFilter];
            setLocalStorageFilters(
                this.state.datatableName + "." + filtrableColsInitState.selectedShowClients.urlKey,
                FOLLOW_UPS.classificationFilter
            );
            updateCurrentURLV2(filtrableColsInitState.selectedShowClients.urlKey, urlValues);
        }

        this.setState({
            filters,
            filtrableCols: {
                ...this.state.filtrableCols,
                selectedShowClients: filtrableCols["selectedShowClients"],
            } /** Avoids re-rendering all the columns (SelectHeaderV2). */,
            checkedDisplayClients: !isShowClientsChecked,
            fetchingCheckboxFilter: true
        });

        this.getData(0, this.props.limit, this.props.q, this.state.sortBy, filters);
    }

    toggleClosedFollowUps() {
        const isClosedFiltered = this.state.filters.includes(FOLLOW_UPS.closedFilter);
        const isOpenFiltered = this.state.filters.includes(FOLLOW_UPS.archiveFilter);

        const { formatMessage } = this.context.intl;
        let filters = "";

        let filtrableCols = JSON.parse(JSON.stringify(this.state.filtrableCols));
        const statusLocales = followUpStatusTypes.map((status) => {
            return {
                followUpStatusType: formatMessage({ id: status.key }),
                followUpStatusTypeVal: status.value,
            };
        });

        const { selectedStatuses } = this.state.filtrableCols;
        let statusColFilters = [];
        let urlValues = [];

        if (isClosedFiltered && isOpenFiltered) {
            filters = this.state.filters.filter((filter) => !filter.includes(FOLLOW_UPS.closedFilter));
            filtrableCols["selectedStatuses"]["items"] = [];
            filtrableCols["selectedStatuses"]["apiFilters"] = [];
        } else {
            filters = [...new Set([...this.state.filters, FOLLOW_UPS.closedFilter, FOLLOW_UPS.archiveFilter])];
            filtrableCols["selectedStatuses"]["items"] = [...statusLocales];
            statusColFilters = [FOLLOW_UPS.archiveFilter, FOLLOW_UPS.closedFilter];
            filtrableCols["selectedStatuses"]["apiFilters"] = statusColFilters;
            urlValues = selectedStatuses.filterList.map((value) => value[selectedStatuses.key]);
        }

        setLocalStorageFilters(
            this.state.datatableName + "." + filtrableColsInitState.selectedStatuses.urlKey,
            statusColFilters.length > 0 ? statusColFilters.join(";") : ""
        );

        updateCurrentURLV2(selectedStatuses.urlKey, urlValues);

        const isChecked = !(
            isClosedFiltered && isOpenFiltered
        ); /** If checkbox click event was triggered, and closed and open filters were applied, it means we just removed them. */
        this.setState({
            filters,
            filtrableCols: {
                ...this.state.filtrableCols,
                selectedStatuses: filtrableCols["selectedStatuses"],
            } /** Avoids re-rendering all the columns (SelectHeaderV2). */,
            checkClosedFollowUps: isChecked,
            fetchingCheckboxFilter: true
        });

        this.getData(0, this.props.limit, this.props.q, this.state.sortBy, filters);
    }

    updateFollowUp(values) {
        this.setState({ fetchingCheckboxFilter: true });
        let memberId = values.memberId; /** Can be int in some cases. */
        if (typeof memberId == "string") {
            memberId = values.memberId.trim() ? values.memberId : null;
        }
        /** Need to be set to null cause db wont accept string for int field. */
        if (values.followUpAttachments && values.followUpAttachments.length > 0) {
            values.followUpAttachments.forEach((followUpAttachment) => {
                followUpAttachment.objectPath.startsWith(`${getTenantFromURL()}/`) ?
                    followUpAttachment.objectPath = followUpAttachment.objectPath.replace(`${getTenantFromURL()}/`, '') :
                    followUpAttachment.objectPath;
            });
        }
        const dataToUpdate = {
            followUpId: values.followUpId,
            attachments: values.followUpAttachments,
            followUpType: values.followUpType,
            description: values.description,
            transactionAmount: values.transactionAmount || null,
            recipientUserId: values.recipientUserId,
            followUpCategoryId: values.followUpCategoryId,
            memberId: memberId,
            clientId: values.clientId,
            memberIdentifier: values.memberIdentifier
        };
        if (values.priority) {
            dataToUpdate.priority = values.priority;
            dataToUpdate.deadline = values.deadline;
        }
        if (!values.memberId && !values.clientId) {
            dataToUpdate.memberName = values.memberName;
            dataToUpdate.memberIdentifier = values.memberIdentifier;
            dataToUpdate.memberClient = values.memberClient;
            dataToUpdate.memberPhoneNumber = values.memberPhoneNumber;
            dataToUpdate.memberEmailAddress = values.memberEmailAddress;
        }
        if (values.generateFollowUp) {
            switch (values.followUpType) {
                case INCIDENT.value: {
                    dataToUpdate.incidentType = values.subType;
                    dataToUpdate.specialModificationType = null;
                    break;
                }
                case SPECIAL_MODIFICATION.value: {
                    dataToUpdate.specialModificationType = values.subType;
                    dataToUpdate.incidentType = null;
                    break;
                }
            }
        }
        if (values.closeFollowUp) {
            dataToUpdate.followUpStatusType = "CLOSED";
            dataToUpdate.closedDate = new Date();
            dataToUpdate.closedByUserId = this.props.auth.user.userId;
        } else {
            dataToUpdate.followUpStatusType = "OPEN";
            dataToUpdate.closedDate = null;
            dataToUpdate.closedByUserId = null;
        }
        dataToUpdate.closedDescription = values.closedDescription;
        return this.props.dataActions.updateDataItem(FOLLOW_UPS, dataToUpdate).then((data) => {
            if (data.type === "UPDATE_DATA_ITEM_FAILURE") {
                if (data.payload.error.data.error === "invalidDataFollowUp") {
                    toast(<FormattedMessage id="invalidDataFollowUp" />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                }
            }
            this.props.dataActions.getDataCount(
                FOLLOW_UPS,
                [FOLLOW_UPS.archiveFilter, `followUps.recipient_user_id==${this.props.auth.user.userId}`],
                "FOLLOW_UPS"
            );

            this.getData(this.props.offset, this.props.limit, this.props.q, this.state.sortBy, this.state.filters);
        });
    }

    updateFollowUps(values) {
        const followUpObject = {};

        if (values.recipientUserId) {
            followUpObject.recipientUserId = values.recipientUserId;
        }

        if (values.followUpCategoryId) {
            followUpObject.followUpCategoryId = values.followUpCategoryId;
        }

        if (values.closeFollowUp) {
            followUpObject.followUpStatusType = "CLOSED";
            followUpObject.closedDate = new Date();
            followUpObject.closedByUserId = this.props.auth.user.userId;

            if (values.closedDescription) {
                followUpObject.closedDescription = values.closedDescription;
            }
        }

        if (values.closeFollowUp || values.recipientUserId || values.followUpCategoryId) {
            const dataToUpdate = this.state.selection.map((followUpId) => ({
                followUpId,
                ...followUpObject,
            }));

            this.setState({
                showSelectedCheckboxes: 0,
                fetchingCheckboxFilter: true
            });

            return this.props.dataActions.updateDataItem(FOLLOW_UPS, dataToUpdate).then((data) => {
                if (data.type === "UPDATE_DATA_ITEM_FAILURE") {
                    if (data.payload.error.data.error === "invalidDataFollowUp") {
                        toast(<FormattedMessage id="invalidDataFollowUp" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                }
                this.props.dataActions.getDataCount(
                    FOLLOW_UPS,
                    [FOLLOW_UPS.archiveFilter, `followUps.recipientUserId==${this.props.auth.user.userId}`],
                    "FOLLOW_UPS"
                );

                this.getData(this.props.offset, this.props.limit, this.props.q, this.state.sortBy, this.state.filters);
            });
        }
    }

    findNestedState(state, nestedKey, byColKey = undefined) {
        for (const stateName in state["filtrableCols"]) {
            if (
                state["filtrableCols"][stateName] &&
                state["filtrableCols"][stateName][byColKey ? "col" : "key"] == nestedKey
            ) {
                return stateName;
            }
        }
        return null;
    }

    resetFiltersState(resetActiveSearches) {
        this.setState(
            {
                filtrableCols: JSON.parse(
                    JSON.stringify(filtrableColsInitState)
                ) /** Deep copy is needed to not modify the initstate object. */,
                filters: [],
                checkClosedFollowUps: false,
                checkedDisplayClients: false
            },
            () => this.reload()
        );
        this.props.formActions.change("followUpsFilter", "followUpsFilter", "");
        resetActiveSearches(undefined, undefined, true);
    }

    onColChange(selectedValues, colKey, newFilters = undefined, sortBy = undefined) {
        const nestedStateName = this.findNestedState(this.state, colKey);
        if (!sortBy) {
            let filtersToApply = newFilters ? newFilters.split(";").filter(Boolean) : ""; // Boolean only keeps truthy values.
            const statusKey = this.state.filtrableCols.selectedStatuses.key;

            if (colKey === statusKey) {
                let isClosedSelected = false;
                let isOpenSelected = false;

                let isIncludedClosed = false;

                selectedValues.forEach((val) => {
                    if (val[statusKey].toUpperCase() === "CLOSED") {
                        isClosedSelected = true;
                    } else if (val[statusKey].toUpperCase() === "OPEN") {
                        isOpenSelected = true;
                    }
                });
                isIncludedClosed = isClosedSelected && isOpenSelected;

                this.setState({ checkClosedFollowUps: isIncludedClosed });
            }

            this.setState((prevState) => ({
                filtrableCols: {
                    ...prevState.filtrableCols,
                    [nestedStateName]: {
                        ...prevState["filtrableCols"][nestedStateName],
                        items: selectedValues,
                        apiFilters: filtersToApply,
                    },
                },
            }));
            return filtersToApply; // Returning here since setState is async.
        }
    }

    setAsyncSearchFilter(colKey, filterToApply) {
        let nestedStateName = null;
        let currentAPIFilters = null;

        let allAPIFiltersForCol = [];

        if (colKey === "priority" || colKey === "followUpStatusType") {
            nestedStateName = this.findNestedState(this.state, colKey, true);
        } else {
            nestedStateName = this.findNestedState(this.state, colKey);
            currentAPIFilters = this.state.filtrableCols[nestedStateName].apiFilters;
        }

        /**
         * We want to remove any previous like filter in the state.
         */

        if (currentAPIFilters) {
            let existingLikeFilterIndex = -1;

            currentAPIFilters.forEach((filter, i) => {
                if (filter.includes("=like=")) {
                    existingLikeFilterIndex = i;
                }
            });

            if (existingLikeFilterIndex > -1) {
                currentAPIFilters.splice(existingLikeFilterIndex, 1);
            }

            allAPIFiltersForCol = allAPIFiltersForCol.concat(currentAPIFilters);
        }

        filterToApply && allAPIFiltersForCol.push(filterToApply);

        this.setState((prevState) => ({
            filtrableCols: {
                ...prevState.filtrableCols,
                [nestedStateName]: {
                    ...prevState["filtrableCols"][nestedStateName],
                    apiFilters: allAPIFiltersForCol,
                },
            },
        }));
    }

    reapplyFilters(refresh = false) {
        let updatedFilters = [];
        for (const colState in this.state["filtrableCols"]) {
            const apiFilters = this.state["filtrableCols"][colState]["apiFilters"];

            if (apiFilters) {
                if (apiFilters) updatedFilters = updatedFilters.concat(apiFilters);
            }
        }

        this.setState({ filters: updatedFilters });
        const { offset, limit, q } = this.props;


        if (refresh) {
            this.getData(offset, limit, q, this.state.sortBy, updatedFilters); // Since setState is async, we need to pass updatedFilters
        }


        return updatedFilters;
    }

    updateMasterCheckbox() {
        const selection = [];
        let countCheckbox = 0;

        for (let checkbox in this.checkboxes) {
            if (this.checkboxes.hasOwnProperty(checkbox) && this.checkboxes[checkbox]) {
                if (this.checkboxes.hasOwnProperty(checkbox)) {
                    if (this.checkboxes[checkbox].checked) {
                        countCheckbox += 1;
                        selection.push(checkbox);
                    }
                }
            }
        }
        if (countCheckbox > 0) {
            this.props.followUpActions.setFollowUp(countCheckbox);
        }
        this.setState({ showSelectedCheckboxes: countCheckbox });
        this.setState({ selection });
    }

    createFilterLists(key) {
        const followUpData = this.props.followUps;
        const colsToModify = [
            "memberName",
            "createdAt",
            "deadline",
            "description",
            "createdByUser",
            "recipientUser",
            "client",
        ];

        let values = new Set();
        let filterList = [];

        if (followUpData && followUpData.length > 0) {
            followUpData.map((fu) => {
                switch (key) {
                    case "memberName":
                        values.add(
                            fu.memberName
                                ? fu.memberName
                                : fu.member
                                    ? fu.member.firstName + " " + fu.member.lastName
                                    : null
                        );
                        break;
                    case "createdAt":
                        values.add(fu.createdAt && fu.createdAt.split("T")[0]);
                        break;
                    case "deadline":
                        values.add(fu.deadline && fu.deadline.split(" ")[0]);
                        break;
                    case "description":
                        values.add(fu.description && !fu.descriptionKey && fu.description);
                        break;
                    case "createdByUser":
                        values.add(fu.createdByUser && `${fu.createdByUser.firstName} ${fu.createdByUser.lastName}`);
                        break;
                    case "recipientUser":
                        values.add(fu.recipientUser && `${fu.recipientUser.firstName} ${fu.recipientUser.lastName}`);
                        break;
                    case "client":
                        values.add(fu.client && fu.client.name);
                        break;
                }
            });

            if (values.size > 0) {
                filterList = Array.from(values).map((value) => {
                    return { [key]: value };
                });
            }
        }

        if (colsToModify.includes(key)) {
            const stateName = this.findNestedState(this.state, key);

            this.setState((prevState) => ({
                filtrableCols: {
                    ...prevState.filtrableCols,
                    [stateName]: {
                        ...prevState["filtrableCols"][stateName],
                        filterList: filterList,
                    },
                },
            }));
        }
    }

    getCols() {
        this.checkboxes = {};

        const fuCols = getFollowUpCols({
            filtrableCols: this.state.filtrableCols,
            onHeaderFilterChange: this.onColChange,
            updateMasterCheckbox: this.updateMasterCheckbox,
            checkboxes: this.checkboxes,
            setCellClassNames: this.setCellClassNames,
            paginationQuery: "limit=0"
        });

        return fuCols;
    }
    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }

    generateCustomItemOptions() {
        const customItemOptions = {
            generateComponent: this.generateActionButtons,
            widthPct: 5.99,
        };

        return customItemOptions;
    }

    generateActionButtons(followUp) {
        const isArchivedMember = followUp.member && followUp.member.isArchived && !userHasAccess(FINTECH);
        const isArchivedClient = followUp.client && followUp.client.isArchived;
        return (
            <div className="follow-ups-action-btn">
                <ButtonToolbar key={followUp.followUpId}>
                    <EditButton
                        modalClassName="extra-large-modal modal-follow-ups"
                        confirmationTitle={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                {this.renderFormatedMessage}
                            </FormattedMessage>
                        }
                        confirmationMessage={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                        }
                        closeButtonKey="common.cancel"
                        requiresCloseConfirmation={true}
                        confirmOnClose={true}
                        title={
                            followUp.followUpStatusType === "OPEN" ? (
                                <FormattedMessage id="followUps.list.datatable.actions.edit" />
                            ) : (
                                <FormattedMessage id="followUps.list.datatable.actions.view" />
                            )
                        }
                        form={BasicFollowUpFields}
                        readOnly={isArchivedMember || isArchivedClient}
                        props={{
                            isArchivedMember,
                            isArchivedClient
                        }}
                        view={followUp.followUpStatusType !== "OPEN" || isArchivedMember}
                        getData={() => this.createEditableFollowUpModel(followUp.followUpId)}
                        editFunction={this.updateFollowUp}
                        reload={this.reloadForModal}
                        allowSubmission={!isArchivedMember && !isArchivedClient}
                    />
                </ButtonToolbar>
            </div>
        );
    }

    generateAddButton() {
        const { selection } = this.state;
        let mapping = {};
        mapping.showSelectedCheckboxes = this.state.showSelectedCheckboxes;
        return (
            <div>
                <CheckboxButton
                    className="include-archived"
                    id="showOnly"
                    label={
                        <span>
                            <FormattedMessage id="followUps.list.datatable.actions.showOnly" />
                            <span className="client-word-style"><FormattedMessage id="clients.title" /></span>
                        </span>
                    }
                    disabled={this.state.fetchingCheckboxFilter}
                    checked={this.state.filters.includes(FOLLOW_UPS.classificationFilter) || this.state.checkedDisplayClients}
                    onClick={this.toggleShowClients}
                />
                <CheckboxButton
                    className="include-archived"
                    id="archived"
                    label={<FormattedMessage id="followUps.list.datatable.actions.includeClosedFollowUps" />}
                    checked={
                        (this.state.filters.includes(FOLLOW_UPS.closedFilter) &&
                            this.state.filters.includes(FOLLOW_UPS.archiveFilter)) ||
                        this.state.checkClosedFollowUps
                    }
                    disabled={this.state.fetchingCheckboxFilter}
                    onClick={this.toggleClosedFollowUps}
                />
                <DropdownButton
                    className="note-type"
                    id="note-type"
                    title={<FormattedMessage id="followUps.list.datatable.actions.followUpTypes.title" />}
                >
                    <MenuItem eventKey="1" onClick={this.openFollowUpForm.bind(this, "NOTE")}>
                        <FormattedMessage id="followUps.list.datatable.actions.followUpTypes.note" />
                    </MenuItem>
                    <MenuItem eventKey="2" onClick={this.openFollowUpForm.bind(this, "INCIDENT")}>
                        <FormattedMessage id="followUps.list.datatable.actions.followUpTypes.incidentFollowUp" />
                    </MenuItem>
                    <MenuItem eventKey="3" onClick={this.openFollowUpForm.bind(this, "SPECIAL_MODIFICATION")}>
                        <FormattedMessage id="followUps.list.datatable.actions.followUpTypes.specialModification" />
                    </MenuItem>
                </DropdownButton>
                <BSModal
                    className="extra-large-modal modal-follow-ups"
                    show={this.state.showModal}
                    title={<FormattedMessage id="followUps.list.datatable.actions.add" />}
                    actions={[
                        {
                            id: 1,
                            disabled: false,
                            text: <FormattedMessage id="common.confirm" />,
                            action: this.onClick,
                        },
                    ]}
                    onClose={this.closeFollowUpForm}
                >
                    <div>
                        <BasicFollowUpFields
                            ref={"form"}
                            onSubmit={this.onSubmit}
                            initialValues={this.createEmptyFollowUpModel()}
                            add={true}
                        />

                        <BSModal
                            backdrop={false}
                            show={this.state.showConfirmationModal}
                            closeButtonKey="common.cancel"
                            actions={[
                                {
                                    id: 1,
                                    disabled: false,
                                    text: <FormattedMessage id="common.confirm" />,
                                    action: this.confirmOnClose,
                                },
                            ]}
                            onClose={this.closeConfirmationModal}
                            title={
                                <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                    {this.renderFormatedMessage}
                                </FormattedMessage>
                            }
                        >
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                        </BSModal>
                    </div>
                </BSModal>

                <ButtonToolbar>
                    <EditButton
                        datatableActionButton={false}
                        modalClassName="medium-modal modal-follow-ups"
                        confirmationTitle={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                {this.renderFormatedMessage}
                            </FormattedMessage>
                        }
                        confirmationMessage={
                            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                        }
                        closeButtonKey="common.cancel"
                        requiresCloseConfirmation={true}
                        confirmOnClose={true}
                        title={<FormattedMessage id="followUps.list.datatable.actions.edit" />}
                        label={
                            <FormattedMessage id="common.modifyNumberCheckBoxUsed" values={mapping}>
                                {(m) => (
                                    <span className="formatted-confimation" dangerouslySetInnerHTML={{ __html: m }} />
                                )}
                            </FormattedMessage>
                        }
                        form={MultiFollowUpFields}
                        editFunction={this.updateFollowUps}
                        visible={!!selection.length}
                    />
                </ButtonToolbar>
            </div>
        );
    }

    reload() {
        this.getData(this.props.offset, this.props.limit, this.props.q, this.state.sortBy, this.state.filters);
    }

    reloadForModal() {
        this.setState({ fetchingCheckboxFilter: true });
        this.getData(this.props.offset, this.props.limit, this.props.q, this.state.sortBy, this.state.filters);
    }

    generateFilterButton() {
        const { overrideToMe } = this.state;
        return (
            <FollowUpsFilter
                initialValues={{ followUpsFilter: !overrideToMe ? TO_ME.value : "", memberFilter: {} }}
                onChange={this.updateFollowUpFilters}
                options={followUpFilters}
                deactivateCheckboxes={this.deactivateCheckboxes}
            />
        );
    }

    getData(
        offset,
        limit,
        q,
        sortBy,
        filters,
        forceGetData,
        searchedCols,
        searchColKey = undefined,
        isFrontFilter = false,
        clearFilterList = false
    ) {
        searchedCols = searchedCols || [];
        // Clear selection, ref list and reset master
        if (this.checkboxes.master) {
            this.checkboxes = { master: this.checkboxes.master };
            this.checkboxes.master.checked = false;
        } else {
            this.checkboxes = {};
        }

        this.setState({
            showSelectedCheckboxes: 0,
            selection: [],
            filters: filters,
        });
        if (forceGetData || this.props.followUpsFetched) {
            let graphQLFilters = "";
            let graphQLSort = "";

            /**
             * If we have no filter on the STATUS col, we want to add followUps.followUpStatusType==OPEN, by default.
             */

            const filteredStatusIndex = filters.findIndex((elem) => elem.includes("followUps.followUpStatusType"));
            if (filteredStatusIndex === -1) {
                filters = [...filters, FOLLOW_UPS.archiveFilter];
            }

            filters = filters.filter((f) => f);
            sortBy = sortBy.filter((s) => s);
            if (filters) {
                graphQLFilters = toGraphQLFormat(filters);
                graphQLFilters = formatMultipleFilters(graphQLFilters);
            }
            if (sortBy) {
                graphQLSort = toGraphQLSortFormat(sortBy);
            }
            const graphQLQuery = this.getGraphQLQuery(graphQLFilters, graphQLSort, offset, limit, "getFollowUps", q);

            return this.props.dataActions
                .getGraphQL(FOLLOW_UPS_GRAPHQL, { query: graphQLQuery }, graphQLSort)
                .then(() => {
                    searchedCols &&
                        searchedCols.map((colKey) => {
                            /**
                             * For every request, we refresh the filter lists of the current active searches. (Determined by DTV2 and SelectHeaderV2).
                             * This is helpful when we change the offset, and want correct results in the filter dropdowns.
                             */
                            this.createFilterLists(colKey);
                        });

                    if (!isFrontFilter && clearFilterList) {
                        this.clearFilterList(searchColKey);
                    }

                    this.setState({ fetchingCheckboxFilter: false });
                });
        }
        return Promise.resolve();
    }

    getColsAPIFilters() {
        let filters = [];

        for (const colState in this.state["filtrableCols"]) {
            const apiFilters = this.state["filtrableCols"][colState]["apiFilters"];

            if (apiFilters) {
                filters = filters.concat(apiFilters);
            }
        }

        return filters;
    }

    updateFollowUpFilters(fields, existingFilterAndSort, overridableFilter = false, initCall = false) {

        this.setState({
            showSelectedCheckboxes: 0,
        });

        let sortBy = null;
        const filterType = fields.followUpsFilter.trim();
        const userId = this.props.auth.user.userId;
        let filters = this.state.filters.filter((filter) => filter.includes(FOLLOW_UPS.archiveFilter));

        if (existingFilterAndSort && existingFilterAndSort.hasOwnProperty("existingFilters")) {
            const apiColFilters = this.getColsAPIFilters();
            filters = [...filters, ...apiColFilters];
            sortBy = [
                existingFilterAndSort.existingSortBy
                    ? existingFilterAndSort.existingSortBy
                    : "follow_ups.created_at:asc",
            ];

        }

        let isCategoryFilter = new RegExp("[0-9]", "g").test(parseInt(filterType));

        if (!isCategoryFilter && !overridableFilter) {
            switch (filterType) {
                case TO_ME.value: {
                    filters.push(`followUps.recipient_user_id==${userId}`);
                    break;
                }
                case FROM_ME.value: {
                    filters.push(
                        `followUps.created_by_user_id==${userId};follow_ups.have_been_transfered_by_current_user==true`
                    );
                    break;
                }
                default: {
                    break;
                }
            }
        } else if (isCategoryFilter) {
            filters.push(`follow_ups.follow_up_category_id==${filterType}`);
        }

        if (fields.memberFilter.length && fields.memberFilter[0].memberId) {
            const memberId = fields.memberFilter[0].memberId;
            const memberName = `${fields.memberFilter[0].firstName} ${fields.memberFilter[0].lastName}`;
            filters.push(`follow_ups.member_id==${memberId};follow_ups.member_name==${memberName}`);
        }

        let colFilters = this.reapplyFilters();
        if (colFilters.includes(FOLLOW_UPS.archiveFilter)) {
            const index = filters.indexOf(FOLLOW_UPS.archiveFilter);
            filters.splice(index, 1);
        }
        filters = filters.concat(colFilters);

        if (!_.isEqual(this.state.filters, filters) || this.props.followUps === null) {
            let uniqueFilters = Array.from(new Set([...filters])).map((filter) => filter);
            this.setState({ filters: uniqueFilters });

            if (!initCall) {
                this.getData(
                    0,
                    this.props.limit,
                    this.props.q,
                    sortBy ? sortBy : this.state.sortBy,
                    uniqueFilters,
                    true,
                );
            }
        }
    }
    render() {
        const { limit, offset } = this.props;

        const pagination = { rowsPerPage: limit, offset };
        const userLocale = localStorage.getItem("languageCode") || "en-CA";

        return (
            <DataTableV2
                ref="dataTableV2"
                title={<FormattedMessage id="followUps.title" />}
                getData={this.getData}
                cols={this.getCols()}
                offset={this.props.offset}
                hideQ={true}
                filters={this.state.filters}
                data={this.props.followUps}
                pagination={pagination}
                rowHeight={56}
                showOverflow={true}
                totalRows={this.props.total}
                sortBy={this.state.sortBy}
                customDataTableOptions={this.generateAddButton()}
                filterDataTableOptions={this.generateFilterButton()}
                showSelectedCheckboxes={this.state.showSelectedCheckboxes}
                generateFilters={this.generateFilters}
                reapplyFilters={this.reapplyFilters}
                dataTableName={this.state.datatableName}
                setAsyncFilters={this.setAsyncSearchFilter}
                tableName="follow_ups"
                customItemOptions={this.generateCustomItemOptions()}
                isGraphQL={true}
                showEmptyFiltersBtn={true}
                resetFiltersState={this.resetFiltersState}
                customEmptyBtnFilterClass={userLocale == "en-CA" ? "empty-filters-w-en" : ""}
                deactivateCheckboxes={this.deactivateCheckboxes}
            />
        );
    }
}

FollowUpsDataTable.propTypes = {
    auth: PropTypes.object,
    dataActions: PropTypes.object,
    followUpActions: PropTypes.object,
    q: PropTypes.string,
    filters: PropTypes.array,
    limit: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    followUps: PropTypes.array,
    followUpsFetched: PropTypes.bool,
    showSelectedCheckboxes: PropTypes.number,
    formActions: PropTypes.object,
    followUpCategories: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

FollowUpsDataTable.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state) {
    const data = state.data.followUps || {};
    const categories = state.data.followUpCategories || {};

    return {
        auth: state.auth || {},
        limit: data.limit || 50,
        q: data.q,
        filters: data.filters || [],
        offset: data.offset || 0,
        sortBy: data.sortBy || [],
        total: data.totalCount || 0,
        followUps: data.items || null,
        followUpsFetched: !!data.fetched,
        followUpCategories: categories.items || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        followUpActions: bindActionCreators(followUpActions, dispatch),
        dataActions: bindActionCreators(dataActions, dispatch),
        formActions: bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/list/FollowUpsDataTable.js